export function isVimeoUrl(url) {
  return Boolean(url && /vimeo\.com\/\d+/.test(url))
}

export function vimeoEmbedUrl(url, { background = false } = {}) {
  const match = url.match(/vimeo\.com\/(\d+)(?:\/([a-f0-9]+))?/)
  if (!match) return url
  const [, id, hash] = match
  const params = new URLSearchParams()
  if (hash) params.set('h', hash)
  if (background) {
    params.set('autoplay', '1')
    params.set('muted', '1')
    params.set('loop', '1')
    params.set('background', '1')
  }
  const qs = params.toString()
  return `https://player.vimeo.com/video/${id}${qs ? '?' + qs : ''}`
}
